import { cn } from "@btnet/utilities-core";

import { BTIconBookOpen } from "commonComponents/btWrappers/BTIcon";

interface ILinkedCostItemIconProps {
    costItemId?: number | null;
    marginTop: "xs" | "xss";
    paddingTop?: boolean;
}

export const LinkedCostItemIcon: React.FunctionComponent<ILinkedCostItemIconProps> = ({
    costItemId,
    marginTop,
    paddingTop,
}) => {
    if (costItemId !== 0 && costItemId) {
        const className = cn(`margin-top-${marginTop} margin-left-xs`, {
            "padding-top-lg": paddingTop,
        });
        const title = "Editing line item will break the link to the Cost Catalog Item";

        return <BTIconBookOpen className={className} title={title} />;
    }
    return null;
};
